import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'btx-profile-campaign-info-modal',
  templateUrl: './profile-campaign-info-modal.component.html',
  styleUrls: ['./profile-campaign-info-modal.component.scss'],
  standalone: false
})
export class ProfileCampaignInfoModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public profileCampaignInfoDescription: string) { }

  ngOnInit(): void {
  }

}
